<template>

    <div class="input-group interval-picker">
        <span class="input-group-addon input-group-addon-pre hidden-xs p-0" v-if="pre_label !== ''">{{ pre_label }}</span>
        <span class="input-group-btn">
            <input type="number" maxlength="3" class="form-control" v-model="interval">
        </span>

        <span class="input-group-btn">
            <select name="sending_interval_type" id="sending_interval_type" class="form-control" v-model="interval_type">
                <option value="H" v-if="available_intervals.includes('H')">{{ transChoice('global.hours', interval) }}</option>
                <option value="D" v-if="available_intervals.includes('D')">{{ transChoice('global.days', interval) }}</option>
                <option value="W" v-if="available_intervals.includes('W')">{{ transChoice('global.weeks', interval) }}</option>
                <option value="M" v-if="available_intervals.includes('M')">{{ transChoice('global.months', interval) }}</option>
            </select>
        </span>

        <span class="input-group-btn">
          <select class="form-control" v-model="interval_modifier">
            <option
                v-for="option in intervalModifierOptions"
                :key="option.value"
                :value="option.value"
            >
              {{ option.label }}
            </option>
          </select>
        </span>

        <span class="input-group-addon p-0" v-if="post_label !== ''">{{ post_label }}</span>
    </div>
</template>

<script>
export default {

    data() {
        return {
            interval_modifier: '+',
            interval_type: 'H',
            interval: 0,
        };
    },
    props: {
        pre_label: {
            default: '',
        },
        post_label: {
            default: '',
        },
        available_intervals: {
            default: () => ['M', 'W', 'D', 'H'],
        },
        value : {},

        is_cancellation: {
            type: Boolean,
            default: false
        },

        is_before_appointment: {
            type: Boolean,
            default: undefined
        }
    },

    mounted() {
        this.parseValue(this.value);
    },

    methods: {
        parseValue(value) {
            let regex = /^([-+]*)P(\d+M)*(\d+W)*(\d+D)*T*(\d+H)*$/;
            let matches = (value || '').match(regex);

            if (typeof value !== 'string' || value.indexOf('P') < 0 || !matches) {
                // invalid interval
                return this.reset();
            }

            let [fullMatch, modifier, months, weeks, days, hours] = matches;

            this.interval_modifier = ['-', '+'].includes(modifier) ? modifier : '+';
            
            if (months) {
                this.interval_type = 'M';
                this.interval = parseInt(months) || 0;
            } else if (weeks) {
                this.interval_type = 'W';
                this.interval = parseInt(weeks) || 0;
            } else if (days) {
                this.interval_type = 'D';
                this.interval = parseInt(days) || 0;
            } else {
                this.interval_type = 'H';
                this.interval = parseInt(hours) || 0;
            }
        },

        reset() {
            this.interval_modifier = ['+', '-'].includes(this.interval_modifier) ? this.interval_modifier : '+';
            this.interval_type = ['M', 'W', 'D', 'H'].includes(this.interval_type) ? this.interval_type : 'H';
            this.interval = 0;
        },
    },

    computed: {
        finalValue() {
            if (!this.interval || this.interval == 0 || this.interval == '') {
                return '';
            }

            let timeModifier = this.interval_type == 'H' ? 'T' : '';

            return `${this.interval_modifier}P${timeModifier}${this.interval}${this.interval_type}`;
        },

        intervalModifierOptions() {
            if (this.is_before_appointment === undefined) {
                return [
                    { label: this.trans('global.before'), value: '-' },
                    { label: this.trans('global.after'), value: '+' }
                ];
            }

            return this.is_before_appointment
                ? [{ label: this.trans('global.before'), value: '-' }]
                : [{ label: this.trans('global.after'), value: '+' }];
        }
    },

    watch: {
        finalValue(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.$emit('input', newValue);
            }
        },

        value(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.parseValue(newValue);
            }
        },

        is_before_appointment: {
            immediate: true,
            handler(newValue) {
                this.interval_modifier = newValue ? '-' : '+';
            }
        }
    }
}
</script>

<style scoped>
.interval-picker .input-group-addon-pre{
    max-width: 158px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border: 1px solid #E3E3E3;
}>
.interval-picker .input-group-addon-post{
    max-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
     border: 1px solid #E3E3E3;
}
</style>
